import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './ToastBanner.module.scss';
import warningTriangleSVG from '../../../assets/images/svg/warning-triangle.svg';

const UPGRADE_TYPE = 'upgrade';

const ToastBanner = ({
  children,
  title,
  type,
  onClickCloseButton,
  whiteSpaceWarp,
  addToCart,
}) => (
  <div
    className={classnames(styles.wrapper, styles[type], {
      [styles['cart-add-item']]: addToCart,
    })}
  >
    <>
      {title && (
        <div className={styles.toastTitle}>
          {type === UPGRADE_TYPE && <div className={styles.upgradeIcon} />}
          <div data-testid="title" className={styles.title}>
            {title}
          </div>
        </div>
      )}
      {onClickCloseButton && (
        <div
          className={styles['btn-close-toast']}
          role="button"
          tabIndex="0"
          onClick={onClickCloseButton}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onClickCloseButton();
            }
          }}
          data-testid="btn-close-toast"
          aria-label={title}
        />
      )}
    </>

    <div
      className={classnames(styles.content, {
        [styles['content-error']]: type === 'error',
        [styles.whiteSpaceWarp]: whiteSpaceWarp,
      })}
    >
      <>
        {type === 'error' && (
          <div className={styles['warning-icon']}>
            <img src={warningTriangleSVG} alt="Warning" />
          </div>
        )}
        {children}
      </>
    </div>
  </div>
);

ToastBanner.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  type: PropTypes.oneOf(['error', 'warning', 'info', 'upgrade']).isRequired,
  onClickCloseButton: PropTypes.func,
  whiteSpaceWarp: PropTypes.string,
  addToCart: PropTypes.bool,
};

ToastBanner.defaultProps = {
  title: '',
  onClickCloseButton: null,
  whiteSpaceWarp: null,
  addToCart: false,
};

export default ToastBanner;
